module.exports = __webpack_public_path__ + "img/2b4f69068900480d9b23bdc7973ee2fe-60.af68c3e0.png";